// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import the events
import { NeedNewSiteVersion } from '@/events/app/NeedNewSiteVersion'

export const GetAppVersion = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService,
        NeedNewSiteVersion

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        refreshing: false,
        registration: null,
        updateExists: false

    }),

    /*
	**  Do this first
    */

    created() {

        /*  
        **  Listen for our custom event from the SW registration
        */

        document.addEventListener('serviceWorkerUpdateEvent', this.updateAvailable, { once: true });
 
        /*  
        **  Prevent multiple refreshes
        */

        navigator.serviceWorker.addEventListener('controllerchange', () => {

            if (this.refreshing) return;

            this.refreshing = true;

        })

    },

    /*
    **  Watch em'
    */

    watch: {

        //

    },

    /*
	**  Methods
    */
    
    methods: {

        updateAvailable: function(event) {

            /*  
            **  Update the props
            **  @props: @here
            */

            this.registration = event.detail;
            this.updateExists = true;

            /*  
            **  Update the user doc
            **  @event: Events/App/NeedNewSiteVersion
            */

            this.needNewSiteVersionHandler();

        },

        refreshApp: function() {

            /*  
            **  Update the prop
            **  @prop: @here
            */

            this.updateExists = false;
 
            /*  
            **  Make sure we only send a 'skip waiting' message if the SW is waiting
            */

            if (!this.registration || !this.registration.waiting) return;

            /*  
            **  Send message to SW to skip the waiting and activate the new SW
            */

            this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });

        }

    },

    /*
    **  Set the computed props
    */

    computed: {

        

    },

}